import React, { useCallback, useState } from 'react';
import CompareDiff from './CompareDiff.jsx';

export default function HashValueChange({ data, ...props }) {
  const state = {
    current: data[0].current,
    proposed: data[0].proposed,
    impact: data[0].summary,
  };
  const [reviewed, setReviewed] = useState(false);

  const handleReviewed = useCallback(() => {
    setReviewed(true);
  });

  return (
    <div className='diff-compare'>
      <div
        className='ui content summary'
        id='impact-table'
      >
        <If condition={!reviewed}>
          <h3 className='ui header'>Review all changes before saving</h3>
        </If>
        <If condition={reviewed}>
          <h3 className='ui header'>
            All changes were reviewed <i className='icon check circle' />
          </h3>
        </If>
        <CompareDiff
          {...props}
          current={state.current}
          proposed={state.proposed}
          reviewedHandler={handleReviewed}
        />
      </div>
    </div>
  );
}
